import { REHYDRATE } from 'redux-persist';
import get from 'lodash/get';
import SharedState from './state';
import { SharedTypes } from './types';

const INITIAL_STATE = new SharedState();

export default function sharedReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    // UPLOAD_FILE
    case SharedTypes.UPLOAD_FILE.LOADING:
      return {
        ...state,
        uploadFile: {
          loading: {
            ...get(state, 'uploadFile.loading', {}),
            [action.payload]: true,
          },
          data: {
            ...get(state, 'uploadFile.data', {}),
            [action.payload.id]: {},
          },
          error: {
            ...get(state, 'uploadFile.error', {}),
            [action.payload.id]: null,
          },
        },
      };
    case SharedTypes.UPLOAD_FILE.SUCCESS:
      return {
        ...state,
        uploadFile: {
          loading: {
            ...get(state, 'uploadFile.loading', {}),
            [action.payload.id]: false,
          },
          data: {
            ...get(state, 'uploadFile.data', {}),
            [action.payload.id]: action.payload.data,
          },
          error: {
            ...get(state, 'uploadFile.error', {}),
            [action.payload.id]: null,
          },
        },
      };
    case SharedTypes.UPLOAD_FILE.ERROR:
      return {
        ...state,
        uploadFile: {
          loading: {
            ...get(state, 'uploadFile.loading', {}),
            [action.payload.id]: false,
          },
          data: {
            ...get(state, 'uploadFile.data', {}),
            [action.payload.id]: {},
          },
          error: {
            ...get(state, 'uploadFile.error', {}),
            [action.payload.id]: action.payload.error,
          },
        },
      };
    case SharedTypes.UPLOAD_FILE.RESET:
      return {
        ...state,
        uploadFile: {
          loading: {},
          data: {},
          error: {},
        },
      };

    // UPLOAD_MULTIPLE_FILE
    case SharedTypes.UPLOAD_MULTIPLE_FILE.LOADING:
      return {
        ...state,
        uploadMultipleFile: {
          loading: {
            ...get(state, 'uploadMultipleFile.loading', {}),
            [action.payload]: true,
          },
          data: {
            ...get(state, 'uploadMultipleFile.data', {}),
            [action.payload.id]: {},
          },
          error: {
            ...get(state, 'uploadMultipleFile.error', {}),
            [action.payload.id]: null,
          },
        },
      };
    case SharedTypes.UPLOAD_MULTIPLE_FILE.SUCCESS:
      return {
        ...state,
        uploadMultipleFile: {
          loading: {
            ...get(state, 'uploadMultipleFile.loading', {}),
            [action.payload.id]: false,
          },
          data: {
            ...get(state, 'uploadMultipleFile.data', {}),
            [action.payload.id]: action.payload.data,
          },
          error: {
            ...get(state, 'uploadMultipleFile.error', {}),
            [action.payload.id]: null,
          },
        },
      };
    case SharedTypes.UPLOAD_MULTIPLE_FILE.ERROR:
      return {
        ...state,
        uploadMultipleFile: {
          loading: {
            ...get(state, 'uploadMultipleFile.loading', {}),
            [action.payload.id]: false,
          },
          data: {
            ...get(state, 'uploadMultipleFile.data', {}),
            [action.payload.id]: {},
          },
          error: {
            ...get(state, 'uploadMultipleFile.error', {}),
            [action.payload.id]: action.payload.error,
          },
        },
      };
    case SharedTypes.UPLOAD_MULTIPLE_FILE.RESET:
      return {
        ...state,
        uploadMultipleFile: {
          loading: {},
          data: {},
          error: {},
        },
      };

    default:
      return state;
  }
}
